<template>
    <div class="">
        <div class="row no-gutters vh-100">
            <!-- left col -->
            <div class="col-lg-6 d-flex justify-content-center mt-6 mt-lg-24 relative">
                <div class="absolute container -top-4 left-0 w-full flex justify-end">
                    <a href="/register?lang=it" class="font-bold mr-2 sm:mr-4">Ita</a>
                    <a href="/register?lang=en" class="font-bold sm:mr-4">Eng</a>
                </div>
                <div class="container pb-10 flex items-center">
                    <div class="max-w-sm mx-auto">
                        <div class="flex mb-5">
                            <a href="/" class="block mr-4">
                                <img class="h-10" src="images/logo_login.png" />
                            </a>
                            <!--
                            <a href="/" class="block">
                                <img class="h-10" src="images/fondo-sociale-europeo_logo.png" />
                            </a>
                            -->
                        </div>

                        <!-- Form -->
                        <form @submit.prevent="submit">
                            <div class="mb-5">
                                <div class="text-black font-16px">
                                    {{ $t("insert_your_data") }}
                                </div>
                                <div class="input-label-secondary font-14px">
                                    {{ $t("are_already_registered") }}
                                    <Link :href="route('login')">
                                        {{ $t("login") }}
                                    </Link>
                                </div>
                            </div>

                            <jet-validation-errors class="mb-4" />

                            <div class="js-form-message form-group">
                                <input type="text" class="form-control form-control-sm" name="first_name" :placeholder="$t('first_name')" onfocus="this.placeholder=''" onblur="this.placeholder='Nome'" v-model="form.first_name" required data-msg="Please enter a valid email address." />
                            </div>

                            <div class="js-form-message form-group">
                                <input type="text" class="form-control form-control-sm" name="last_name" :placeholder="$t('last_name')" onfocus="this.placeholder=''" onblur="this.placeholder='Cognome'" v-model="form.last_name" required data-msg="Please enter a valid email address." />
                            </div>
                            <div class="js-form-message form-group">
                                <input type="email" class="form-control form-control-sm" name="email" placeholder="Email" onfocus="this.placeholder=''" onblur="this.placeholder='Email'" v-model="form.email" required data-msg="Please enter a valid email address." />
                            </div>

                            <!-- Form Group -->
                            <div class="js-form-message form-group">
                                <div class="input-group input-group-merge">
                                    <input
                                        type="password"
                                        class="js-toggle-password form-control form-control-sm"
                                        name="password"
                                        placeholder="Crea password"
                                        v-model="form.password"
                                        onfocus="this.placeholder=''"
                                        onblur="this.placeholder='Crea password'"
                                        aria-label="8+ characters required"
                                        required=""
                                        data-msg="Your password is invalid. Please try again."
                                        data-hs-toggle-password-options="{
                             'target': '#changePassTarget',
                             'defaultClass': 'tio-hidden-outlined',
                             'showClass': 'tio-visible-outlined',
                             'classChangeTarget': '#changePassIcon'
                           }"
                                    />
                                </div>
                            </div>

                            <div class="js-form-message form-group">
                                <div class="input-group input-group-merge">
                                    <input
                                        type="password"
                                        class="js-toggle-password form-control form-control-sm"
                                        name="password_confirmation"
                                        id="signupSrPassword"
                                        :placeholder="$t('password_confirmation')"
                                        v-model="form.password_confirmation"
                                        onfocus="this.placeholder=''"
                                        onblur="this.placeholder='Conferma password'"
                                        aria-label="8+ characters required"
                                        required=""
                                        data-msg="Your password is invalid. Please try again."
                                        data-hs-toggle-password-options="{
                             'target': '#changePassTarget',
                             'defaultClass': 'tio-hidden-outlined',
                             'showClass': 'tio-visible-outlined',
                             'classChangeTarget': '#changePassIcon'
                           }"
                                    />
                                </div>
                            </div>
                            <!-- End Form Group -->
                            <!-- Terms and Privacy -->
                            <div class="form-group">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" id="terms" class="custom-control-input" v-model="form.terms" checked />
                                    <label class="custom-control-label" for="terms">
                                        {{ $t("i_read_the") }}
                                        <a target="_blank" href="/privacy-policy" class="underline text-sm text-gray-600 hover:text-gray-900">
                                            {{ $t("privacy_policy") }}
                                        </a>
                                    </label>
                                </div>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" id="other" class="custom-control-input" v-model="form.data_sending" checked />
                                    <label class="custom-control-label" for="other">
                                        {{ $t("authorize_data_transmissions") }}
                                    </label>
                                </div>
                            </div>
                            <!-- End Terms and Privacy -->

                            <button type="submit" class="btn btn-primary" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ $t("register") }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <!-- right col -->
            <div class="d-none d-lg-block col-lg-6 justify-content-center">
                <div class="bg-from-yellow-to-white text-center h-100 flex flex-col justify-center">
                    <img src="images/lamp_img.png" class="mx-auto" width="60%" />
                    <div class="font-72px text-yellow font-lato-black font-weight-bold">
                        {{ $t("register") }}
                    </div>
                    <div class="text-black font-16px font-lato-regular">
                        {{ $t("create_an_account") }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import JetValidationErrors from "../../Jetstream/ValidationErrors";
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        JetValidationErrors,
        Link,
    },

    data() {
        return {
            form: this.$inertia.form({
                first_name: "",
                last_name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: true,
                data_sending: true,
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("register"), {
                onFinish: () => this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>

<style scoped>
.bg-from-yellow-to-white {
    background: linear-gradient(to bottom, #f9dfab 0%, #f2b436 100%);
}

.text-yellow {
    color: #d08c00;
}

.text-black {
    color: #141414;
}
</style>
